<template>
    <div class="flex flex-col md:flex-row gap-6">
        <div class="flex flex-col gap-6">
            <h2 class="text-2xl md:text-4xl font-semibold">Patient Overview: Initial Presentation</h2>

            <div>
                <h3 class="text-base md:text-2xl font-semibold">
                    A 13-year-old boy with a history of recurrent urolithiasis since age 2 years presented at a Saudi hospital with ESKD
                </h3>
            </div>

            <div>
                <div class="flex flex-col gap-3">
                    <div class="p-5 text-white rounded bg-darkerblue">
                        The patient had left flank pain associated with nausea, vomiting, dysuria, and hematuria
                    </div>
                </div>
            </div>
            <div>
                <h3 class="text-base md:text-2xl font-semibold mb-3">Relevant medical history</h3>
                <div class="flex flex-col gap-3">
                    <div class="p-5 text-white rounded bg-maroon">
                        History of recurrent kidney stones since early childhood
                    </div>
                    <div class="p-5 text-white rounded bg-purple">
                        Elevated urinary oxalate of 579 mmol/L and impaired right kidney function identified at age 4 years
                    </div>
                </div>
            </div>

            <div>
                <h3 class="text-base md:text-2xl font-semibold mb-3">Family history</h3>
                <ul class="list-disc pl-4 font-light">
                    <li>Born to consanguineous parents</li>
                    <li>Family history of kidney stones in his elder brother, grandmother, and paternal uncle</li>
                </ul>
            </div>
        </div>

        <img src="@/assets/img/graphics/adolescent/child-grey.svg" alt="Boy body" :style="{ maxHeight: '780px' }" />
    </div>
</template>
